import {REQUEST_PRICE_RATE, REQUEST_PRICE_RATE_FAILURE, REQUEST_PRICE_RATE_SUCCESS} from "../../../constant/PriceRateConstant";

const initialState = {
    price_rate: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const priceRateReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_PRICE_RATE:
            return {
                ...state,
                price_rate: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_PRICE_RATE_SUCCESS:
            return {
                ...state,
                price_rate: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_PRICE_RATE_FAILURE:
            return {
                ...state,
                price_rate: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
